import $ from 'jquery'
import { isNonEmptyString, tsInitVue } from './js-utils'
import type { CancellationReason } from './vue-components/types'
import CancelRegistrationModal from './vue-components/cancel-registration-modal.vue'
import ParticipantActivityManager from './vue-components/participant-activity-manager.vue'

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body.event-participants .registration-form, body.event-preview .registration-form, body.open-registration .registration-form, body.event-participant-registration-details .registration-form, body.event-reimbursements .registration-form')) {

    const cancelModalEl = document.querySelector('div[data-is="CancelRegistrationModal"]')
    if (cancelModalEl instanceof HTMLElement) {
      let cancellationReasons = [] as CancellationReason[]
      const reasonsStr = cancelModalEl.dataset.cancellationReasons
      if (isNonEmptyString(reasonsStr)) {
        cancellationReasons = JSON.parse(reasonsStr)
        if (!Array.isArray(cancellationReasons)) {
          cancellationReasons = []
        }
      }

      const cancelModal = tsInitVue(CancelRegistrationModal, cancelModalEl, {
        registrationUrl: cancelModalEl.dataset.registrationUrl ?? '',
        cancelUrl: cancelModalEl.dataset.cancelUrl ?? '',
        cancellationReasons: cancellationReasons
      })
      $('[data-action=cancel-participation]').click(function (e) {
        e.preventDefault();
        (cancelModal as any).showModal()
      })
    }

    const activityManagerEl = document.querySelector('div[data-is="ParticipantActivityManager"]')
    if (activityManagerEl instanceof HTMLElement) {
      window.activityManager = tsInitVue(ParticipantActivityManager, activityManagerEl, {
        readonly: activityManagerEl.dataset.readonly == 'true'
      })
    }

    const $refundTypeRow = $('div[ref="refund-type-row"]:first')
    const participantStatusEl = $('select[ref="status-id"]:first').get(0)
    const transportRefundEl = $('select[ref="transport-refund-type"]:first').get(0)
    const perDiemRefundEl = $('select[ref="per-diem-refund-type"]:first').get(0)
    const $participantBankDetails = $('fieldset[ref="participant-bank-details"]:first')
    const $institutionBankDetails = $('fieldset[ref="institution-bank-details"]:first')
    const $refundInfoRows = $('div[ref="refund-info-row"]')

    const participantBankType = $participantBankDetails.data('refund-type')
    const institutionBankType = $institutionBankDetails.data('refund-type')

    const enableBankDetails = function (): void {
      let bankDetailsHidden = false
      if (participantStatusEl instanceof HTMLSelectElement) {
        const statusId = parseInt(participantStatusEl.value)
        if (statusId === 3) {
          bankDetailsHidden = true

          // hide all bank details fields
          $refundTypeRow.addClass('d-none')
          $participantBankDetails.addClass('d-none')
          $institutionBankDetails.addClass('d-none')
          $participantBankDetails.attr('disabled', '')
          $institutionBankDetails.attr('disabled', '')

          $refundInfoRows.addClass('d-none')
        } else {
          $refundTypeRow.removeClass('d-none')
        }
      }

      if (bankDetailsHidden) {
        return
      }

      if (transportRefundEl instanceof HTMLSelectElement && perDiemRefundEl instanceof HTMLSelectElement) {
        const v1 = parseInt(transportRefundEl.value)
        const v2 = parseInt(perDiemRefundEl.value)

        if (v1 === participantBankType || v2 === participantBankType) {
          $participantBankDetails.removeClass('d-none')
          $refundInfoRows.eq(0).removeClass('d-none')
          $participantBankDetails.removeAttr('disabled')
        } else {
          $participantBankDetails.addClass('d-none')
          $refundInfoRows.eq(0).addClass('d-none')
          $participantBankDetails.attr('disabled', '')
        }

        if (v1 === institutionBankType || v2 === institutionBankType) {
          $institutionBankDetails.removeClass('d-none')
          $refundInfoRows.eq(1).removeClass('d-none')
          $institutionBankDetails.removeAttr('disabled')
        } else {
          $institutionBankDetails.addClass('d-none')
          $refundInfoRows.eq(1).addClass('d-none')
          $institutionBankDetails.attr('disabled', '')
        }
      }
    }

    if (participantStatusEl) {
      participantStatusEl.addEventListener('change', function () {
        enableBankDetails()
      })
    }

    if (transportRefundEl) {
      transportRefundEl.addEventListener('change', function () {
        enableBankDetails()
      })
    }

    if (perDiemRefundEl) {
      perDiemRefundEl.addEventListener('change', function () {
        enableBankDetails()
      })
    }

    const experienceWithCasesWrapEl = document.querySelector('[ref="experience-with-cases"]')
    if (experienceWithCasesWrapEl instanceof HTMLElement) {
      const experienceWithCasesRadioEl = experienceWithCasesWrapEl.querySelector('input[type="radio"][data-show-experience="1"]')
      const experienceWithCasesDetailsWrapEL = document.querySelector('[ref="experience-with-cases-details"]')
      if (experienceWithCasesRadioEl instanceof HTMLInputElement && experienceWithCasesDetailsWrapEL instanceof HTMLElement) {
        const onRadioChangedCB = function () {
          // show/hide experience with cases text field
          experienceWithCasesDetailsWrapEL.style.display = experienceWithCasesRadioEl.checked ? '' : 'none'
        }

        experienceWithCasesWrapEl.querySelectorAll(':scope input[type="radio"]').forEach((radioEl) => {
          radioEl.addEventListener('change', onRadioChangedCB)
        })

        onRadioChangedCB()
      }
    }

    // set initial state for bank details
    enableBankDetails()
  }
})
